module.exports = __webpack_public_path__ + "img/avatar-stroke.1deca92b.png";